/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

if($('body').hasClass('template-collection')){
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    var loadingImage,
    pInfScrNode = $('.collection__results-product-list-more').last(),	
    pInfScrURL = $('.collection__results-product-list-more').last().attr("href");
    // removeing this condition && pInfScrNode.css('display') != 'none'
    if(!pInfScrLoading && pInfScrNode.length > 0) {
      $('product-list').append('<div class="loader_wrapper"><img src="https://cdn.shopify.com/s/files/1/0635/5795/9924/files/loading.gif?v=1735378390" class="collection__results-product-list-loading" /></div>');
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          // $('.collection__results-product-list-more').hide();
          // loadingImage = pInfScrNode.clone().empty().append('');
          // loadingImage.insertAfter(pInfScrNode);
          // pInfScrNode.hide();
          
          console.log('loading...');
        },
        success: function(data) {
          var filteredData = $(data).find("product-list .product-list__inner");
          $('product-list .product-list__inner').append(filteredData.html());
          if($(data).find('.collection__results-product-list-more_wrapper').length > 0){          
            $('.collection__results-product-list-more_wrapper').html($(data).find('.collection__results-product-list-more_wrapper').html());
          }else{
            $('.collection__results-product-list-more_wrapper').remove();
          }
          $('product-list .loader_wrapper').remove();
          pInfScrLoading = false;        
        },
        dataType: "html"
      });
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      var eletop = $('product-list .product-list__inner').offset().top + $('.product-list .product-list__inner').height();
      if( eletop + 100 < $(document).scrollTop() + $(window).height()) {
        pInfScrExecute();
      }
    });
  });
}

$(document).ready(function(){

  $(".testimonial-secondary-list").slick({
      arrows:true,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $(".popular-combos_item-list").slick({
      arrows:true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 999,
          settings: "unslick" // 🔥 remove slick on mobile
        }
      ]
  });
  $('.trusted-by_media-list').slick({
    mobileFirst: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnHover: false,
    variableWidth: true,

    responsive: [
      {
        breakpoint: 741, // >= 999px (desktop)
        settings: "unslick"
      }
    ]
  });

 $('body').on('click','.product-form__dropdown-title', function(){
    var activeTitle = $(this);
    activeTitle.toggleClass('active');
    var currentDropdown = activeTitle.next('.product-form__dropdown-content');
    $('.product-form__dropdown-title').not(activeTitle).removeClass('active');
    $('.product-form__dropdown-content').not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

  $('body').on('click','.video-slider-block-button', function(){
    $(this).addClass('active');
    $(this).closest('.product-meta-video-list-block').find('.pro-meta-video-cover-img').addClass('active');
    const video = $(this).closest('.product-meta-video-list-block').find('.video-slider-block-video')[0];
    video.play();
    video.controls = true;
    console.log('video',video)
 });

  setInterval(()=>{
    const v = document.getElementById('viewers');
    let n = parseInt(v.textContent)+(Math.random()>.5?1:-1);
    v.textContent=Math.max(11,Math.min(27,n));
  },3500);

  if($('#deliver-date-timer').length){
    const days = $('#deliver-date-timer').attr('data-day');
    const hours = $('#deliver-date-timer').attr('data-hours');
    const minute = $('#deliver-date-timer').attr('data-min');
    console.log('days',days);
    console.log('hours',hours);
    console.log('minute',minute);
    const duration = (days * 24 * 60 * 60 * 1000) + (hours * 60 * 60 * 1000) + (minute * 60 * 1000);
    let endDate = new Date().getTime() + duration;
    setInterval(() => {
      const now = new Date().getTime();
      // restart automatically
      if(now >= endDate){
        endDate = new Date().getTime() + duration;
      }
      const distance = endDate - now;
      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );
      const m = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );
      const s = Math.floor(
        (distance % (1000 * 60)) / 1000
      );
      let timerHTML = '';
      if (d > 0) {
        timerHTML += `${d}d `;
      }
      if (h > 0) {
        timerHTML += `${h}h `;
      }
      timerHTML += `${m}m ${s}s`;
      document.getElementById('deliver-date-timer').innerHTML = timerHTML;
    }, 1000)
  }
  
});

if ($('#count-section').length > 0) {
  var counted = 0;

  function counter() {
    var oTop = $('#count-section').offset().top - window.innerHeight;
    if (counted === 0 && $(window).scrollTop() > oTop) {
      $('.count-sec-item-num').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-num');

        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 3000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
            }
          }
        );
      });

      counted = 1;
      $(window).off('scroll', counter); // Remove scroll event after animation runs
    }
  }

  $(window).on('scroll', counter);
}

